





















import Vue from 'vue';
import { IBarometerDataOverview, IBarometerDataPoints } from '@/common/interfaces/barometer.interface';
import RevenueBarometerData from '../components/RevenueBarometerData.vue';
import RevenueBarometerOverview from '../components/RevenueBarometerOverview.vue';

export default Vue.extend({
  components: { RevenueBarometerData, RevenueBarometerOverview },
  props: {
    disableNavigationButton: {
      default: false,
      type: Boolean,
    },
    overviewData: {
      required: true,
      type: Object as () => IBarometerDataOverview,
    },
    pointsData: {
      required: true,
      type: Object as () => Partial<IBarometerDataPoints>,
    },
  },
});
